<template>
  <h3 :class="classes">
    <slot/>
  </h3>
</template>

<script>
export default {
  name: 'mdc-title',
  props: {
    typo: {
      type: String,
      default: 'headline6'
    }
  },
  computed: {
    classes () {
      return 'mdc-title mdc-typography--' + this.typo
    }
  }
}
</script>
